// File uploading
document.addEventListener('DOMContentLoaded', (event) => {
    if (document.querySelectorAll('form .upload-attachments').length){
        document.querySelectorAll('form .upload-attachments').forEach(function(el){
            
            
            el.addEventListener("change", function (event) {
                
                var url = '/upload.pl',
                    input = event.target,
                    form = input.form,
                    fileList = form.querySelector('.file-list'),
                    input_hidden = form.querySelector('[name^="attachment_files"]'),
                    btnSubmit = form.querySelector('[type="submit"]');
                    // collect files
                    files = input.files,
                    formData = new FormData(),
                    filesSize = 0,
                    filesSizeMaxMB = 20,
                    filesSizeMax = filesSizeMaxMB * 1024 * 1024;

                // clear filelist & hidden input
                fileList.innerHTML = '';
                input_hidden.value = '';

                // calculate total filesize
                for(let i=0; i<files.length; i++){
                    filesSize += files[i].size;
                };

                if (filesSize == 0){
                    
                    // no files
                
                } else if (filesSize > filesSizeMax){

                    // max filesize warning to filelist
                    fileList.insertAdjacentHTML('beforeend', `<div class="alert alert-warning" role="alert">Max: <b>${filesSizeMaxMB} MB</b>!</div>`);

                } else {

                    // fill uploaded files to filelist for view
                    for(let i=0; i<files.length; i++){
                        formData.append(files[i].name, files[i]);
                        fileList.insertAdjacentHTML('beforeend', `<div class="mt-2 ps-1"><b class="text-primary">+</b> ${files[i].name}</div>`);
                    }

                    // post form data
                    var xhr = new XMLHttpRequest();
                    
                    // fill response data to hidden input for module
                    xhr.onload = () => {

                        var xmlResponse = xhr.responseXML,
                            xmlFiles = xmlResponse.querySelectorAll('file'),
                            files = [];
                        
                        if (xmlFiles.length){
                            xmlFiles.forEach(function(el){
                                files.push(el.querySelector('hash').textContent + '/' + el.querySelector('fullname').textContent);
                            });
                        };

                        input_hidden.value = files;
                    };
    
                    // start
                    xhr.addEventListener('loadstart', function(e){
                        form.classList.add('uploading');
                        btnSubmit.disabled = 1;
                    });
                    
                    // progress
                    xhr.upload.addEventListener('progress', function(e){
                        var percentComplete = e.loaded / e.total * 100;
                        percentComplete = percentComplete.toFixed(0);
                        form.querySelector('[name="upload_progress"]').textContent = percentComplete + '%';
                    });
                    
                    // end: load, error, abort, or timeout
                    xhr.addEventListener('loadend', function(e){
                        form.classList.remove('uploading');
                        btnSubmit.disabled = 0;
                    });
                                    
                    // create and send the reqeust
                    xhr.open('POST', url, true);
                    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                    xhr.setRequestHeader("Cache-Control", "no-cache");
                    xhr.setRequestHeader("Content-Type", "multipart/form-data");
                    xhr.send(formData);
    
                };
            });


        });
    };
});
